import React from 'react';
import EditorChrome from './EditorChrome';
import {journalPapers, conferencePapers} from '../Content/PortfolioContent';

const PaperCard = ({paper, type}) => {
    const body = (
        <>
            <div className="paper-meta">
                <span>{type}</span><span>{paper.venue}</span><span>{paper.year}</span>
            </div>
            <h2>{paper.title}</h2>
            <p>{paper.detail}</p>
            <strong>{paper.link ? <>View paper <span aria-hidden="true">↗</span></> : 'Proceedings forthcoming'}</strong>
        </>
    );
    return paper.link
        ? <a className="paper-card" href={paper.link} target="_blank" rel="noreferrer">{body}</a>
        : <article className="paper-card paper-card-pending">{body}</article>;
};

const Publications = () => (
    <main className="container portfolio-shell inner-shell">
        <EditorChrome active="/Publications" />
        <section className="inner-editor">
            <a className="back-link" href="/">Back to homepage</a>
            <div className="page-heading">
                <p>;; Selected peer-reviewed and conference work</p>
                <h1>Publications</h1>
                <span>{journalPapers.length + conferencePapers.length} entries · click any entry to read the paper</span>
                <a className="btn scholar-button" href="https://scholar.google.com/scholar?q=Milan+Marocchi" target="_blank" rel="noreferrer">Open Google Scholar ↗</a>
            </div>
            <section className="paper-section">
                <h2 className="buffer-heading">Journal papers</h2>
                <div className="paper-list">{journalPapers.map(paper => <PaperCard paper={paper} type="journal" key={paper.title} />)}</div>
            </section>
            <section className="paper-section">
                <h2 className="buffer-heading">Conference papers</h2>
                <div className="paper-list">{conferencePapers.map(paper => <PaperCard paper={paper} type="conference" key={paper.title} />)}</div>
            </section>
        </section>
    </main>
);

export default Publications;
